import articleThumbOncology from '../assets/article-oncology-surrogate-endpoints.png';
import articleThumbAntibiotics from '../assets/article-antibiotic-stewardship.png';
import articleThumbBiosimilars from '../assets/article-biosimilars-patient-guide.png';
import articleThumbCardiovascular from '../assets/article-cardiovascular-risk.png';
import articleThumbSleep from '../assets/article-sleep-apnea-screening.png';
import articleThumbGlp1 from '../assets/article-glp1-muscle-mass.png';

export const articles = [
  {
    id: '1',
    path: '/articles/oncology-surrogate-endpoints',
    imageUrl: articleThumbOncology,
    title: 'Interpreting surrogate endpoints in oncology trials',
    author: 'Dr. Ananya Sharma',
    date: 'May 2, 2026',
    dateTime: '2026-05-02',
  },
  {
    id: '2',
    path: '/articles/antibiotic-stewardship-outpatient',
    imageUrl: articleThumbAntibiotics,
    title: 'Antibiotic stewardship in outpatient settings',
    author: 'Vikram Desai, PharmD',
    date: 'April 28, 2026',
    dateTime: '2026-04-28',
  },
  {
    id: '3',
    path: '/articles/biosimilars-patient-guide',
    imageUrl: articleThumbBiosimilars,
    title: 'What patients should know about biosimilars',
    author: 'Dr. Neha Kapoor, MD',
    date: 'April 21, 2026',
    dateTime: '2026-04-21',
  },
  {
    id: '4',
    path: '/articles/cardiovascular-risk-calculators',
    imageUrl: articleThumbCardiovascular,
    title: 'Cardiovascular risk calculators: limits and context',
    author: 'Dr. Rohan Mehta',
    date: 'April 15, 2026',
    dateTime: '2026-04-15',
  },
  {
    id: '5',
    path: '/articles/sleep-apnea-screening',
    imageUrl: articleThumbSleep,
    title: 'Sleep apnea screening: who benefits most?',
    author: 'Dr. Priya Nair',
    date: 'April 9, 2026',
    dateTime: '2026-04-09',
  },
  {
    id: '6',
    path: '/articles/glp1-muscle-mass',
    imageUrl: articleThumbGlp1,
    title: 'GLP-1 agonists and muscle mass: what the data say',
    author: 'Dr. Rahul Khanna, PhD',
    date: 'April 3, 2026',
    dateTime: '2026-04-03',
  },
];

/** @returns {typeof articles} */
export function filterArticlesForSearch(rawQuery) {
  const q = rawQuery.trim().toLowerCase();
  if (!q) return [];
  return articles.filter(
    (a) => a.title.toLowerCase().includes(q) || a.author.toLowerCase().includes(q)
  );
}
